import { render, staticRenderFns } from "./TaskPublish.vue?vue&type=template&id=787620f6&scoped=true"
import script from "./TaskPublish.vue?vue&type=script&lang=js"
export * from "./TaskPublish.vue?vue&type=script&lang=js"
import style0 from "./TaskPublish.vue?vue&type=style&index=0&id=787620f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_cache-loader@4.1.0_webpack@4.47.0__css-load_736381c0260194bb481b34437055cd65/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787620f6",
  null
  
)

export default component.exports